import {uniqueId} from 'lodash'
import {LOG_TYPES, LOG_ACTIONS} from '@/constants/logTypes'
import avatarUserDefault from '@/assets/images/avatar-user-default.png'

const logsTable = {
  columns: {
    getColumnsData: 'logsColumnsData',
    setColumnsData: 'setLogsColumnsData'
  },
  rows: {
    getRowsData: 'logsRowsData',
    setRowsData: 'setLogsRowsData'
  }
}

const columns = [
  {
    title: 'Date / Time',
    type: 'date',
    style: 'dateWithTime',
    formatDate: 'DD-MMM-YYYY <br> hh:mm:ss a',
    property: 'date'
  },
  {
    title: 'Transaction type',
    property: 'transactionType',
    sortByColumn: true,
    listName: 'transactionType',
    actions: {},
    list: LOG_TYPES.map(item => {
      return {
        id: item.id,
        name: item.title
      }
    })
  },
  {
    title: 'Name',
    property: 'client.clientNickName',
    capitalize: true
  },
  {
    title: 'Action',
    sortByColumn: true,
    possibleInfo: true,
    property: 'transactionAction',
    listName: 'transactionAction',
    actions: {},
    list: LOG_ACTIONS.map(item => {
      return {
        id: item.id,
        name: item.title
      }
    })
  },
  {
    title: 'Reference',
    property: 'reference',
    isDescription: true
  },
  {
    title: 'Country',
    property: 'country',
  },
  {
    title: 'IP',
    property: 'ip',
    type: 'copiedValue',
  },
  {
    title: 'Details',
    property: 'details',
    typeTable: 'logTable'
  },
  {
    title: 'User',
    property: 'user.image.path',
    popup: 'user.username',
    defaultImg: avatarUserDefault,
    class: 'avatars',
    center: true,
    type: 'img',
    capitalize: true
  },
  {
    property: 'action',
    actions: {
      delete: true
    },
    toolbarSingle: true,
    toolbar: {
      hideEditBtn: true,
      hideDeleteBtn: true,
      upload: true
    }
  }
]

const prefix = 'logs_column_'
const logsTableColumns = columns.map(col => {
  col.id = uniqueId(prefix)
  return col
})

export {
  logsTable,
  logsTableColumns
}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/logsTable.js